<template>
  <div style="background-color: #f2f2f2">
    <BreadCrumb class="breadCrumbPosition" :breadcrumb="breadcrumb" />
    <h1 class="testemunhoTitle">{{ $t('opiniao') }}</h1>
    <TestemunhosFilters />
    <div class="row align-center">
      <div class="small-12 medium-9 large-9 columns content">
        <TestemunhosList>
          <TestemunhoItem
            v-for="(item,inx) in listItems"
            @click="() => goToTestemunhoDetail(item)"
            :faculdadename="item.faculdadename"
            :nome="item.nome"
            :depoimento="item.depoimento"
            :curso="item.curso"
            :imagem="item.imagem"
            :key="`${item.nome}${inx}`" />
        </TestemunhosList>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb.vue";
import TestemunhosFilters from "@/containers/testemunhoFilters.vue";
import TestemunhoItem from "@/components/testemunhoslist/TestemunhoItem.vue";
import TestemunhosList from "@/components/testemunhoslist/TestemunhoList.vue";
import { inject, computed, ref } from "vue";
import { useRouter } from 'vue-router';
import { useStore } from '@/stores/store.ts';
import { i18n } from "@/main.js";


export default {
  name: "TestemunhosOverview",
  components: {
    BreadCrumb,
    TestemunhosFilters,
    TestemunhoItem,
    TestemunhosList
  },
  setup(props){

    const store = useStore();

    const fid = inject('initFaculdadeid');
    const cid = inject('initCursoid');

    store.faculdadeid = fid;
    store.cursoid = cid;
    store.getTestemunhos();

    const listItems = computed(()=> store.testemunhos);

    const currentPosition = ref(10);

    const getListItemsFilter = computed(() => {
      return listItems.value.slice(0, currentPosition.value - 1);
    });

    const router = useRouter();

    const goToTestemunhoDetail = testemunho => {
      store.selectTestemunho(testemunho);
      router.push({
        name: "detalhe",
        params: { id: testemunho.name, postid: testemunho.id },
      });
    }

    const { t } = i18n.global; 

    const breadcrumb = ref([
      { ID: 1, text: "Homepage", href: "https://www.uma.pt" },
      { ID: 2, text: t("testemunhos"), route: { to: "/" } },
    ]);

    return {
      breadcrumb,
      getListItemsFilter,
      listItems,
      currentPosition,
      goToTestemunhoDetail
    }

  },
  mounted() {
    window.onscroll = () => {
      if (this.currentPosition < this.listItems.length) {
        let footerHeight =
          document.getElementsByTagName("footer")[0].offsetHeight;
        let content = document.getElementsByClassName("content")[0];
        let contentPadding = parseFloat(
          window.getComputedStyle(content).paddingBottom
        );
        let bottomOfList = document.body.offsetHeight - footerHeight - contentPadding;
        let bottomOfWindow = window.scrollY + window.innerHeight > bottomOfList;
        if (bottomOfWindow) {
          const updatedPosition = this.currentPosition * 2;
          this.currentPosition = updatedPosition < this.listItems.length
              ? updatedPosition
              : this.listItems.length;
        }
      }
    };
  },
  unmounted() {
    window.removeEventListener("scroll",this);
  }
};
</script>

<style scoped lang="scss">
@import "../global.scss";

.content {
  padding-bottom: 80px;
}

.breadCrumbPosition {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
}

.testemunhoTitle {
  text-align: center;
  color: #3f4244;
  padding-top: 110px;
  font-family: "Montserrat SemiBold", serif;
  font-weight: bold;
  font-size: 60px;
}

/*Responsive - ecrãs desktop pequenos*/
@media (max-width: 1440px) {
  .content {
    padding-bottom: 50px;
  }
}

@media (max-width: 1200px) {
  .content {
    padding-right: 0px;
    padding-left: 0px;
  }

  .testemunhoTitle {
    padding-top: 90px;
  }
}

@media (max-width: 1025px) {
  .testemunhoTitle {
    padding-top: 60px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .testemunhoTitle {
    font-size: 40px;
    padding-right: 10%;
    padding-left: 10%;
    padding-top: 80px;
  }
}

@media (max-width: 767px) {
  .content {
    padding-bottom: 10px;
  }
}

@media (max-width: 767px) {
  .testemunhoTitle {
    padding: 30px 10px 0;
    letter-spacing: 0 !important;
    font-family: "Montserrat SemiBold", serif;
    font-size: 20px;
  }
}

/*Responsive - ipad*/

/*Responsive - iphone*/
@media (max-width: 767px) {
  .content {
    padding-bottom: 30px;
  }

  .filter columns {
    padding-left: 0px;
  }
}
</style>
